import styles from './email-log.module.scss';
import { useCourseTableHook } from '../../../requestUtils';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import EmailLogRenderer from './email-log-renderer/email-log-renderer';
import { IEmailLogPeriod } from '../../../_models/email-log-period';
import EmailLogSkeleton from './email-log-skeleton';
import { addDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailLogProps { }

export function EmailLog(props: EmailLogProps) {
  const { t } = useTranslation();
  const { data: emailLogInPeriod, isLoading, dateRange, onDateChange } = useCourseTableHook<IEmailLogPeriod>(`course/emailLog/periode`, { startDate: addDays(new Date(), -30), endDate: new Date() });

  return (<>
    {isLoading ? <EmailLogSkeleton /> :
      <WebkuaTable
        data={emailLogInPeriod}
        dateRange={dateRange}
        onSetDateRange={onDateChange}
        headers={CreateHeaders([
          textHeader("subject", t('emailLog.subject'), HeaderSizeEnum.EXTRA_LARGE, { renderer: 'agGroupCellRenderer' }),
          dateHeader("createdAt", t('standard.date')),
          textHeader("from", t('standard.from'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("to", t('standard.to'), HeaderSizeEnum.EXTRA_LARGE),
        ])}
        expandComponent={EmailLogRenderer}
      />}
  </>);
}

export default EmailLog;
